export const logsheet = [
  {
    depo: "wagle",
    depoNameMarathi: "वागळे आगार",
    logsheetType: "TMT BUS",
    tableData: [
      {
        left: "वागळे आगार",
        center: "परिवहन सेवा, ठाणे महानगरपालिका ठाणे",
        right: "TMT BUS",
      },
      {
        left: "मार्ग क्र.",
        center: "बसफेरी व किलोमीटर पत्रक",
        right: "दिनांक ",
      },
      {
        left: "सिरीयल क्र.",
        center: "आनंदनगर आगार दुरुस्तीपथक क्र. ८२९१९९२५२५, ८२९१९९२५२४",
        right: "चालक क्रमांक :",
      },
      {
        left: "क्रू क्रमांक.",
        center: "सँटीस : ९७७३१६०४५५, कोपरी आगार ब्रेकडाउन ८१२१५५५६१२",
        right: "वाहक क्रमांक :",
      },
      {
        left: "",
        center:
          "वागळे आगार फोन नं. 02225830070/8976589671,टोल फ्री नं. 1800229901,कोपरी आगार 02220812325,",
        right: "",
      },
      {
        left: "",
        center: "वागळे आगार ब्रेकडाउन - 8976550155",
        right: "",
      },
    ],
  },
  {
    depo: "anandnagar",
    depoNameMarathi: "आनंदनगर आगार",
    logsheetType: "Normal",
  },
  {
    depo: "anandnagar",
    depoNameMarathi: "आनंदनगर आगार",
    logsheetType: "Tejasvini",
  },
  {
    depo: "kopari",
    depoNameMarathi: "कोपरी आगार",
    logsheetType: "AC BUS",
    tableData: [
      {
        left: "कोपरी आगार",
        center: "परिवहन सेवा, ठाणे महानगरपालिका ठाणे",
        right: "AC BUS",
      },
      {
        left: "मार्ग क्र.",
        center: "बसफेरी व किलोमीटर पत्रक",
        right: "दिनांक ",
      },
      {
        left: "सिरीयल क्र.",
        center: "आनंदनगर आगार दुरुस्तीपथक क्र. 8291992525, 8291992524",
        right: "चालक क्रमांक :",
      },
      {
        left: "क्रू क्रमांक.",
        center: "सँटीस : 9773160455",
        right: "वाहक क्रमांक :",
      },
      {
        left: "TO",
        center:
          "वागळे आगार फोन नं. 25827785, कळवा आगार फोन नं. 25425193, टोल फ्री नं. 1800229901,",
        right: "",
      },
    ],
  },
  {
    depo: "kopari",
    depoNameMarathi: "कोपरी आगार",
    logsheetType: "Non-AC BUS",
  },
  {
    depo: "wagle_extra",
    depoNameMarathi: "वागळे आगार",
    logsheetType: "",
    tableData: [
      {
        left: "वागळे आगार",
        center: "परिवहन सेवा, ठाणे महानगरपालिका ठाणे",
        right: "TMT BUS",
      },
      {
        left: "मार्ग क्र.",
        center: "बसफेरी व किलोमीटर पत्रक",
        right: "दिनांक ",
      },
      {
        left: "जादा",
        center: "जादा फेरीपत्रक",
        right: "चालक क्रमांक :",
      },
      {
        left: "",
        center: "कळवा आगार वाहतूक 25425193",
        right: "वाहक क्रमांक :",
      },
      {
        left: "",
        center:
          "कळवा आगार",
        right: "",
      },
      {
        left: "",
        center: "वागळे आगार ब्रेकडाउन - 8976550155",
        right: "",
      },
    ],
  },
];
